import {Utilities} from '@learningblocks/exp-constants';
const {
  checkAllSliderGroupsCorrect,
  resetUpdatedKeyInDNDQ,
  VISIBILITY,
} = Utilities;
const NEXT_COMPONENT = 'nextComponent';

export function submitAnswer(state, payload) {
  return {
    ...state,
    currentChapter: updateInCurrentChapter(state.currentChapter, payload),
  };
}

function updateInCurrentChapter(currentChapter, payload) {
  return {
    ...currentChapter,
    components: updateInComponents(currentChapter.components, payload),
  };
}

/**
 *
 * @param {'Array<Object>'} components array of components
 * @param {'number'} payload component ID
 * @returns
 */
function updateInComponents(components, payload) {
  const {newcomponents} = components.reduce(
    (acc, component) => {
      //updating Submitted component
      if (component.id === payload) {
        component = updateInGroupedDNDQ(component);
        if (component.hasOwnProperty(NEXT_COMPONENT)) {
          acc.forward = {
            complete: component.complete,
            nextComponent: component.nextComponent,
          };
        }
      }

      // updating forward component and setting its visibility
      if (
        acc.forward &&
        acc.forward.complete &&
        acc.forward.nextComponent === component.id
      ) {
        component = {...component, visibility: VISIBILITY.VISIBLE};
        acc.forward = null;
      }
      acc.newcomponents = [...acc.newcomponents, component];
      return acc;
    },
    {
      newcomponents: [],
      forward: null,
    }
  );
  return newcomponents;
}

function updateInGroupedDNDQ(component) {
  if (component.totalAttempts === -10 || component.totalAttempts > 0) {
    const complete = checkAllSliderGroupsCorrect(component.sliderGroups);
    let sliderGroups = resetUpdatedKeyInDNDQ(component.sliderGroups);
    if (complete) {
      sliderGroups = disableAllSliders(sliderGroups);
    }
    const totalAttempts =
      component.totalAttempts === -10 ? -10 : component.totalAttempts - 1;
    return {
      ...component,
      complete,
      sliderGroups,
      totalAttempts,
      showFeedback: true,
    };
  } else {
    return {
      ...component,
      complete: true,
      showFeedback: true,
      totalAttempts: 0,
    };
  }
}

function disableAllSliders(sliderGroups) {
  return sliderGroups.map((group) => {
    return {
      ...group,
      sliders: group.sliders.map((slider) => ({...slider, disable: true})),
    };
  });
}
